var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "342.472 132.194 18 18",
    width: "18px",
    height: "18px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2369_2066",
    x1: -0.326581,
    y1: 9.40105,
    x2: 18.2934,
    y2: 9.40105,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1, 0, 0, 1, 342.472046, 132.17099)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F03063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7640"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 359.422 150.194 C 357.339 150.194 355.28 149.74 353.247 148.832 C 351.214 147.924 349.364 146.636 347.697 144.969 C 346.03 143.303 344.743 141.453 343.835 139.419 C 342.926 137.386 342.472 135.328 342.472 133.244 C 342.472 132.944 342.572 132.694 342.772 132.494 C 342.972 132.294 343.222 132.194 343.522 132.194 L 347.572 132.194 C 347.805 132.194 348.014 132.274 348.197 132.432 C 348.38 132.59 348.489 132.778 348.522 132.994 L 349.172 136.494 C 349.205 136.761 349.197 136.986 349.147 137.169 C 349.097 137.353 349.005 137.511 348.872 137.644 L 346.447 140.094 C 346.78 140.711 347.176 141.307 347.635 141.882 C 348.093 142.457 348.597 143.011 349.147 143.544 C 349.664 144.061 350.205 144.54 350.772 144.982 C 351.339 145.424 351.939 145.828 352.572 146.194 L 354.922 143.844 C 355.072 143.694 355.268 143.582 355.51 143.507 C 355.751 143.432 355.989 143.411 356.222 143.444 L 359.672 144.144 C 359.905 144.211 360.097 144.332 360.247 144.507 C 360.397 144.682 360.472 144.878 360.472 145.094 L 360.472 149.144 C 360.472 149.444 360.372 149.694 360.172 149.894 C 359.972 150.094 359.722 150.194 359.422 150.194 Z M 345.497 138.194 L 347.147 136.544 L 346.722 134.194 L 344.497 134.194 C 344.58 134.878 344.697 135.553 344.847 136.219 C 344.997 136.886 345.214 137.544 345.497 138.194 Z M 354.447 147.144 C 355.097 147.428 355.76 147.653 356.435 147.819 C 357.11 147.986 357.789 148.094 358.472 148.144 L 358.472 145.944 L 356.122 145.469 L 354.447 147.144 Z",
    fill: "url(#paint0_linear_2369_2066)",
    id: "object-0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.174abf70af79617ce8234db802c00496.svg";
export { ForwardRef as ReactComponent };